import { fromJS } from 'immutable'
import {
  POSITION_IMPORT_REQUEST,
  POSITION_IMPORT_SUCCESS,
  POSITION_IMPORT_FAILURE,
  POSITION_IMPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case POSITION_IMPORT_REQUEST:
      return state
        .set('isFetching', true)
    case POSITION_IMPORT_SUCCESS:
      return state
        .set('importResult', fromJS(action.payload.importResult))
        .set('isFetching', false)
    case POSITION_IMPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', true)
    case POSITION_IMPORT_RESET:
      return state
        .delete('importResult')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/position/position-import-reducer.js